import {RouteRecordRaw} from "vue-router";
import TransferMarketIndex from '../pages/Index.vue';
import TeamOffersIndex from '../pages/team-offers/Index.vue';
import TeamOffersShow from '../pages/team-offers/Show.vue';
import ListingsIndex from '../pages/listings/Index.vue';

export const routes: RouteRecordRaw[] = [
  {
    path: '/transfer-market',
    name: 'transfer-market.index',
    component: TransferMarketIndex,
  },
  {
    path: '/transfer-market/listings',
    name: 'transfer-market.listings.index',
    component: ListingsIndex,
  },
  {
    path: '/transfer-market/team-offers',
    name: 'transfer-market.team-offers.index',
    component: TeamOffersIndex,
  },
  {
    path: '/transfer-market/team-offers/:id',
    name: 'transfer-market.team-offers.show',
    component: TeamOffersShow,
  }
];